<template>
  <div class="cus-modal" v-loading="loading">
    <div class="subtablePart">
      <Collapse v-model="openDefault">
        <Panel name="1">
          <!-- 基本信息 -->
          {{ $it('com.baseInformation') }}
          <p slot="content">
            <OmsForm :form-config="formConfig" />
          </p>
        </Panel>
        <Panel name="2">
          <!-- 换货人信息 -->
          {{ $it('pL.exchangeInfo') }}
          <p slot="content">
            <OmsForm :form-config="replacement" />
          </p>
        </Panel>
        <div class="salesTable obj-table">
          <!-- tab切换 -->
          <OmsLabel
            class="businessLabel"
            :label-list="labelList"
            :label-default-value="defaultValue"
          />
          <!-- 列表组件 -->
          <div class="tableBox">
            <!-- 订单明细 -->
            <OmsTable
              ref="OmsTable"
              :key="refreshKey"
              :jordan-table-config="jordanTableConfig"
              @on-select="onSelect"
              @on-select-cancel="onSelectCancel"
              @on-select-all="onSelectAll"
              @on-select-all-cancel="onSelectAllCancel"
            />
          </div>
        </div>
      </Collapse>
    </div>
    <OmsButton class="modal-footer" :btn-config="btnConfig" />
  </div>
</template>
<script>
export default {
  name: 'AFTER_SALE_APPLY_ORDER',
  props: {
    componentData: {}
  },
  data() {
    return {
      loading: false,
      refreshKey: Date.now(),
      openDefault: ['1', '2'],
      defaultValue: '1', // 控制tab切换样式
      labelList: [
        {
          label: $it('btn.order_detailed'), // 订单明细
          value: '1',
          isShow: true,
        },
      ],
      btnConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'right', // 按钮位置 (right , center , left)
        buttons: [
          {
            text: $it('com.cancel'), // 取消 按钮文本
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            } // 按钮点击事件
          },
          {
            type: 'primary', // 按钮类型
            text: $it('com.determine'), // 确定 按钮文本
            btnclick: () => {
              this.submit();
            }
          }
        ]
      },
      formConfig: {
        isGrid: true, // 开启响应式栅格
        formValue: {
          // 存储表单得所有值
          PLATFORM_NAME: '', // 平台
          CP_C_SHOP_TITLE: '', // 平台店铺
          CP_C_SHOP_SELLER_NICK: '', // 平台店铺昵称
          RETURN_NO: '', // 平台售后单号
          TID: '', // 平台单号
          AFTER_SALE_TYPE: '', // 售后类型
          RETURN_DATE: '', // 售后申请日期
          CP_C_LOGISTICS_ID: '', // 物流公司
          CP_C_LOGISTICS_ENAME: '', // 物流公司
          LOGISTICS_CODE: '', // 物流单号
          AFTER_SALE_REASON: '', // 售后原因
          AFTER_SALE_REASON_DESC: '', // 售后原因说明
        },
        // 表单非空提示
        ruleValidate: {
          AFTER_SALE_TYPE: [{ required: true, message: ' ', trigger: 'blur' }],
          // LOGISTICS_CODE: [{ required: true, message: ' ', trigger: 'blur' }],
        },
        formData: [
          {
            style: 'input',
            label: '平台',
            disabled: true,
            value: 'PLATFORM_NAME',
            width: '6',
          },
          {
            style: 'input',
            label: '平台店铺',
            disabled: true,
            value: 'CP_C_SHOP_TITLE',
            width: '6',
          },
          {
            style: 'input',
            label: '平台店铺昵称',
            disabled: true,
            value: 'CP_C_SHOP_SELLER_NICK',
            width: '6',
          },
          {
            style: 'input',
            label: '平台售后单号',
            disabled: true,
            value: 'RETURN_NO',
            width: '6',
          },
          {
            style: 'input',
            label: '平台单号',
            disabled: true, // 按钮禁用控制
            value: 'TID',
            width: '6',
          },
          {
            style: 'select', // 下拉框类型
            label: '售后类型',
            width: '6', // 所占宽度宽度
            rules: true,
            value: 'AFTER_SALE_TYPE',
            selectChange: () => this.toggleType(),
            options: [
              // 下拉框选项值
              {
                value: '0',
                label: '退货退款'
              },
              {
                value: '2',
                label: '换货'
              },
            ],
          },
          {
            style: 'input',
            label: '售后申请日期',
            value: 'RETURN_DATE',
            width: '6',
            disabled: true,
          },
          {
            style: 'popInput',
            width: '6',
            value: 'CP_C_LOGISTICS_ID',
            itemdata: {
              col: 1,
              colid: 168212,
              colname: 'CP_C_LOGISTICS_ENAME', // 当前字段的名称
              datelimit: 'all',
              display: 'text', // 显示什么类型，例如xml表示弹窗多选加导入功能，mrp表示下拉多选
              fkdisplay: 'drp', // 外键关联类型
              inputname: 'CP_C_LOGISTICS_ENAME:ENAME', // 这个是做中文类型的模糊查询字段，例如ENAME
              isfk: true, // 是否有fk键
              isnotnull: false, // 是否必填
              isuppercase: false, // 是否转大写
              isBackRowItem: true,
              length: 65535, // 最大长度是多少
              name: '物流公司',
              readonly: false, // 是否可编辑，对应input   readonly属性
              reftable: 'OC_B_RETURN_ORDER', // 对应的表
              reftableid: 24578, // 对应的表ID
              row: 1,
              statsize: -1,
              type: 'STRING', // 这个是后台用的
              valuedata: '', // 这个是选择的值
            },
            oneObj: (e) => {
              if (e) {
                this.formConfig.formValue.CP_C_LOGISTICS_ID = e.rowItem.ID.val
                this.formConfig.formValue.CP_C_LOGISTICS_ENAME = e.rowItem.ENAME.val
                this.formConfig.formValue.CP_C_LOGISTICS_ECODE = e.rowItem.ECODE.val
              }
            },
          },
          {
            style: 'input',
            label: '物流单号',
            value: 'LOGISTICS_CODE',
            width: '6',
          },
          {
            style: 'input',
            label: '售后原因',
            value: 'AFTER_SALE_REASON',
            width: '6',
          },
          {
            style: 'input',
            label: '售后原因说明',
            value: 'AFTER_SALE_REASON_DESC',
            width: '12',
          },
        ],
      }, // 基本信息
      replacement: {
        isGrid: true, // 开启响应式栅格
        formValue: {
          // 存储表单得所有值
          RECEIVER_ID: '', // 收货人
          RECEIVER_NAME: '', // 收货人
          RECEIVER_MOBILE: '', // 收货人手机
          RECEIVER_PHONE: '', // 收货人电话
          RECEIVER_ZIP_CODE: '', // 收货人邮编
          CP_C_REGION_PROVINCE_ENAME: '', // 收货人省份
          CP_C_REGION_CITY_ENAME: '', // 收货人市
          CP_C_REGION_AREA_ENAME: '', // 收货人区
          CP_C_REGION_TOWN_ENAME: '', // 收货人街道
          RECEIVER_ADDRESS: '', // 收货人地址
        },
        // 表单非空提示
        ruleValidate: {
          RECEIVER_NAME: [{ required: false, message: '请输入收货人', trigger: 'blur' }],
          RECEIVER_MOBILE: [{ required: false, message: '请输入收货人手机', trigger: 'blur' }],
          CP_C_REGION_PROVINCE_ENAME: [{ required: false, message: '请选择收货人省份', trigger: 'blur' }],
          CP_C_REGION_CITY_ENAME: [{ required: false, message: '请选择收货人市', trigger: 'blur' }],
          CP_C_REGION_AREA_ENAME: [{ required: false, message: '请选择收货人区', trigger: 'blur' }],
          RECEIVER_ADDRESS: [{ required: false, message: '请输入收货人地址', trigger: 'blur' }],
        },
        formData: [
          {
            style: 'input',
            label: $it('fL.consignee'), // 收货人
            colname: 'RECEIVER_NAME',
            disabled: false, // 按钮禁用控制
            width: '6',
          },
          {
            style: 'input',
            label: $it('fL.consignee_phone'), // 收货人手机
            colname: 'RECEIVER_MOBILE',
            disabled: false, // 按钮禁用控制
            width: '6',
          },
          {
            style: 'input',
            label: $it('fL.consignee_tel'), // 收货人电话
            colname: 'RECEIVER_PHONE',
            disabled: false, // 按钮禁用控制
            width: '6',
          },
          {
            style: 'dropSelect', // 输入框弹框单多选
            width: '6',
            dataAcessKey: 'CP_C_REGION_PROVINCE_ENAME',
            itemdata: {
              col: 1,
              colid: 167814,
              colname: 'CP_C_REGION_PROVINCE_ENAME', // 当前字段的名称
              datelimit: 'all',
              display: 'text', // 显示什么类型，例如xml表示弹窗多选加导入功能，mrp表示下拉多选
              fkdisplay: 'drp', // 外键关联类型
              fkdesc: $it('fL.consignee_province'), // 收货人省份
              inputname: 'CP_C_STORE_IDS:ENAME', // 这个是做中文类型的模糊查询字段，例如ENAME
              isfk: true, // 是否有fk键
              isnotnull: false, // 是否必填
              isuppercase: false, // 是否转大写
              length: 65535, // 最大长度是多少
              name: '收货人省', // $it('fL.consignee_province') 收货人省份 input前面显示的lable值
              readonly: false, // 是否可编辑，对应input   readonly属性
              reftable: 'CP_C_PROVINCE', // 对应的表
              reftableid: 10010, // 对应的表ID
              row: 1,
              statsize: -1,
              type: 'STRING', // 这个是后台用的
              pid: '',
              valuedata: '', // 这个是选择的值
            },
            oneObj: (e) => {
              this.replacement.formValue.CP_C_REGION_CITY_ID = '';
              this.replacement.formValue.CP_C_REGION_CITY_ENAME = '';
              this.replacement.formValue.CP_C_REGION_AREA_ID = '';
              this.replacement.formValue.CP_C_REGION_AREA_ENAME = '';
              this.twoObjs(e);
            },
          },
          {
            style: 'dropSelect', // 输入框弹框单多选
            width: '6',
            dataAcessKey: 'CP_C_REGION_CITY_ENAME',
            itemdata: {
              col: 1,
              colid: 167815,
              colname: 'CP_C_REGION_CITY_ENAME', // 当前字段的名称
              datelimit: 'all',
              display: 'text', // 显示什么类型，例如xml表示弹窗多选加导入功能，mrp表示下拉多选
              fkdisplay: 'drp', // 外键关联类型
              fkdesc: $it('fL.consignee_city'), // 收货人市
              inputname: 'RECEIVER_CITY:ENAME', // 这个是做中文类型的模糊查询字段，例如ENAME
              isfk: true, // 是否有fk键
              isnotnull: false, // 是否必填
              isuppercase: false, // 是否转大写
              length: 65535, // 最大长度是多少
              name: $it('fL.consignee_city'), // 收货人市
              readonly: false, // 是否可编辑，对应input   readonly属性
              reftable: 'CP_C_CITY', // 对应的表
              reftableid: 23864, // 对应的表ID
              refcolval: {
                fixcolumn: 'C_UP_ID',
                expre: 'equal',
                srccol: 'CP_C_REGION_PROVINCE_ENAME',
              },
              row: 1,
              statsize: -1,
              type: 'STRING', // 这个是后台用的
              pid: '',
              valuedata: '', // 这个是选择的值
            },
            oneObj: (e) => {
              this.replacement.formValue.CP_C_REGION_AREA_ID = '';
              this.replacement.formValue.CP_C_REGION_AREA_ENAME = '';
              this.twoObjs(e);
            },
          },
          {
            style: 'dropSelect', // 输入框弹框单多选
            width: '6',
            dataAcessKey: 'CP_C_REGION_AREA_ENAME',
            itemdata: {
              col: 1,
              colid: 167816,
              colname: 'CP_C_REGION_AREA_ENAME', // 当前字段的名称
              datelimit: 'all',
              display: 'text', // 显示什么类型，例如xml表示弹窗多选加导入功能，mrp表示下拉多选
              fkdisplay: 'drp', // 外键关联类型
              fkdesc: $it('fL.aconsignee_area'), // 收货人区
              inputname: 'RECEIVER_AREA:ENAME', // 这个是做中文类型的模糊查询字段，例如ENAME
              isfk: true, // 是否有fk键
              isnotnull: false, // 是否必填
              isuppercase: false, // 是否转大写
              length: 65535, // 最大长度是多少
              name: $it('fL.aconsignee_area'), // 收货人区input前面显示的lable值
              readonly: false, // 是否可编辑，对应input   readonly属性
              reftable: 'CP_C_DISTAREA', // 对应的表
              reftableid: 23863, // 对应的表ID
              row: 1,
              statsize: -1,
              type: 'STRING', // 这个是后台用的
              pid: '',
              valuedata: '', // 这个是选择的值
              refcolval: {
                fixcolumn: 'C_UP_ID',
                expre: 'equal',
                srccol: 'CP_C_REGION_CITY_ENAME',
              }, // 过滤配置
            },
            oneObj: (e) => {
              this.twoObjs(e);
            },
          },
          {
            style: 'input',
            label: '收货人街道',
            disabled: false, // 按钮禁用控制
            value: 'CP_C_REGION_TOWN_ENAME',
            width: '6',
          },
          {
            style: 'input',
            label: $it('fL.consignee_postcode'), // 收货人邮编
            value: 'RECEIVE_ZIP',
            disabled: false, // 按钮禁用控制
            width: '6',
          },
          {
            style: 'input',
            label: $it('fL.aconsignee_address'), // 收货人地址
            colname: 'RECEIVER_ADDRESS',
            disabled: false, // 按钮禁用控制
            width: '12',
          },
        ],
      }, // 换货人信息
      jordanTableConfig: {
        columns: [
          {
            key: 'SG_C_PRO_SN_ECODE',
            title: 'SN码',
          },
          {
            title: $it('fL.barCode'), // 条码
            key: 'PS_C_SKU_CODE',
          },
          {
            title: $it('tL.productNo'), // SPU编码
            key: 'PS_C_PRO_ECODE'
          },
          {
            key: 'PRO_TITLE',
            title: $it("tL.itemNo02"), // SPU名称
          },
          {
            key: 'QTY_REFUND',
            title: '申请数量',
            render: (h, params) => {
              /**
               * SN码为空， 可编辑， 不考虑数量；
               * SN码不为空， 不可编辑， 数量必然是1；
               */
              // if (params.row.SG_C_PRO_SN_ECODE) {
              //   return h('span', {}, params.row.QTY_REFUND)
              // }
              return h(
                'div',
                {
                  style: {
                    width: '100%',
                    display: 'flex',
                    alignitems: 'center',
                    justifyContent: 'space-between',
                  },
                },
                [
                  h(
                    'Input',
                    {
                      class: 'isNone',
                      style: {
                        width: '50px',
                        height: '100%',
                      },
                      props: {
                        value: params.row.QTY_REFUND,
                        autosize: true,
                        regx: /^[1-9]\d*$/,
                      },
                      on: {
                        'on-change': _.debounce((e) => {
                          let value = e.target.value
                          const { RETURNABLE_QTY, AMT_REFUND_SINGLE } = params.row
                          if (RETURNABLE_QTY < value) {
                            value = RETURNABLE_QTY
                            this.$Message.warning({
                              content: '申请数量不能大于可退数量！',
                              duration: 5,
                              top: 80
                            });
                          }
                          this.jordanTableConfig.data[params.index].QTY_REFUND = value;
                          this.jordanTableConfig.data[params.index].REFUND_AMOUNT = (AMT_REFUND_SINGLE * value).toFixed(4)
                          this.refreshKey = Date.now()
                        }, 1000),
                      },
                    },
                    params.row.QTY_REFUND
                  ),
                ]
              );
            },
          },
          {
            key: 'RETURNABLE_QTY',
            title: '可退数量'
          },
          {
            key: 'BUY_QTY',
            title: '购买数量'
          },
          {
            key: 'AMT_REFUND_SINGLE',
            title: '单件退款金额'
          },
          {
            key: 'REFUND_AMOUNT',
            title: '退货金额',
            render: (h, params) => {
              return h(
                'div',
                {
                  style: {
                    width: '100%',
                    display: 'flex',
                    alignitems: 'center',
                    justifyContent: 'space-between',
                  },
                },
                [
                  h(
                    'Input',
                    {
                      class: 'isNone',
                      style: {
                        width: '50px',
                        height: '100%',
                      },
                      props: {
                        value: params.row.REFUND_AMOUNT,
                        autosize: true,
                        regx: /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,4})?$/,
                      },
                      on: {
                        'on-change': _.debounce((e) => {
                          let value = e.target.value
                          const { BUY_QTY, AMT_REFUND_SINGLE } = params.row
                          let MAX = (BUY_QTY * AMT_REFUND_SINGLE).toFixed(4)
                          if (MAX < value) {
                            value = MAX
                            this.$Message.warning({
                              content: `退货金额不能大于${MAX}！`,
                              duration: 5,
                              top: 80
                            });
                          }
                          this.jordanTableConfig.data[params.index].REFUND_AMOUNT = value
                          this.refreshKey = Date.now()
                        }, 1000),
                      },
                    },
                    params.row.QTY_REFUND
                  ),
                ]
              );
            }
          },
          {
            key: 'EXCHANGE_PT_PS_C_SKU_ID',
            title: '换货平台条码ID',
            render: (h, params) => {
              return h('Input', {
                style: {
                  width: '100px',
                  height: '100%',
                  'text-align': 'center'
                },
                props: {
                  value: params.row.EXCHANGE_PT_PS_C_SKU_ID,
                  disabled: this.formConfig.formValue.AFTER_SALE_TYPE != '2'
                },
                on: {
                  'on-change': _.debounce((e) => {
                    params.row.EXCHANGE_PT_PS_C_SKU_ID = e.target.value
                    this.jordanTableConfig.data[params.index] = params.row;
                  }, 1000)
                }
              })
            }
          },
        ],
        data: [], // 数据配置
        selectionData: [],
        pageShow: false, // 控制分页是否显示
        loading: false,
        height: 280, // 表格高度
        isShowDeleteDetailBtn: false, // 控制是否显示删除明细
        indexColumn: true, // 是否显示序号
        isShowSelection: true, // 是否显示checkedbox
        border: true, // 是否显示纵向边框
        total: 0, // 设置总条数
        pageSizeOpts: [15, 30, 45, 60], // 每页条数切换的配置
        pageSize: 15, // 每页条数
        totalData: [], // 总计
      }, // 退货明细
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.loading = true
      this.service.orderCenter.queryAfterSaleApplyOrder({ objid: this.componentData.objid }).then(res => {
        if (res.data.code == 0) {
          const { ocBAfterSaleApplyOrder, ocBAfterSaleApplyOrderItems } = res.data.data
          this.formConfig.formValue = ocBAfterSaleApplyOrder
          this.jordanTableConfig.data = ocBAfterSaleApplyOrderItems.map((i, index) => {
            i._prohibitClickToSelect = true // 禁止单击选中行
            i._flagIndex = index
            return i
          })
          this.toggleType()
        }
      }).finally(() => {
        this.loading = false
      })
    },
    submit() {
      if (!this.formConfig.formValue.AFTER_SALE_TYPE) {
        return this.$Message.warning('请选择售后类型')
      }
      /* if (!this.formConfig.formValue.LOGISTICS_CODE) {
        return this.$Message.warning('请输入物流单号')
      } */
      let flagArr = this.jordanTableConfig.selectionData.map(i => i._flagIndex)
      const ocBAfterSaleApplyOrderItems = this.jordanTableConfig.data.filter(i => flagArr.includes(i._flagIndex))
      if (this.formConfig.formValue.AFTER_SALE_TYPE == '2') { // 售后类型为换货，换货人信息部分字段校验必填
        let msg = ''
        let keys = Object.keys(this.replacement.ruleValidate)
        for (let i=0; i < keys.length; i++) {
          let rule = this.replacement.ruleValidate[keys[i]][0]
          if (rule.required && this.replacement.formValue[keys[i]] == '') {
            msg = rule.message
            break
          }
        }
        if (!!msg) return this.$Message.warning(msg)
        if (!ocBAfterSaleApplyOrderItems.length) {
          return this.$Message.warning('请勾选订单明细')
        }
        let allFull = ocBAfterSaleApplyOrderItems.every(i => !!i.EXCHANGE_PT_PS_C_SKU_ID)
        if (!allFull) {
          return this.$Message.warning('勾选订单明细的换货平台条码ID不能为空')
        }
      } else {
        if (!ocBAfterSaleApplyOrderItems.length) {
          return this.$Message.warning('请勾选订单明细')
        }
      }

      let valid = ocBAfterSaleApplyOrderItems.every(i => i.QTY_REFUND && i.QTY_REFUND <= i.RETURNABLE_QTY)
      if (!valid) {
        return $fcError('勾选订单明细的申请数量必填，且不能大于可退数量')
      }

      this.loading = true
      const params = {
        objid: this.componentData.objid,
        ocBAfterSaleApplyOrder: { ...this.formConfig.formValue, ...this.replacement.formValue },
        ocBAfterSaleApplyOrderItems
      }
      this.service.orderCenter.saveAfterSaleApplyOrder(params).then(res => {
        if (res.data.code == 0) {
          this.$Message.success(res.data.message || '新增成功')
          this.$parent.$parent.closeConfirm();
        }
      }).finally(() => {
        this.loading = false
      })
    },
    toggleType() {
      let isEdit = this.formConfig.formValue.AFTER_SALE_TYPE == '2'
      this.replacement.formData.forEach(i => {
        if (i.style == 'dropSelect') {
          i.itemdata.readonly = !isEdit
          i.itemdata.isnotnull = isEdit
        } else {
          i.disabled = !isEdit
        }
      })
      for (let key in this.replacement.ruleValidate) {
        this.replacement.ruleValidate[key][0].required = isEdit
      }
      !isEdit && $utils.formEmpty(this, 'replacement')
    },
    twoObjs(e) {
      console.log(e)
      const _this = this;
      _this.replacement.formData.forEach((item) => {
        if (item.itemdata) {
          // 收货人省份
          if (item.itemdata.colname == 'CP_C_REGION_PROVINCE_ENAME' && item.itemdata.colname == e.colname) {
            this.replacement.formValue.CP_C_REGION_PROVINCE_ID = item.itemdata.pid;
            this.replacement.formValue.CP_C_REGION_PROVINCE_ENAME = item.itemdata.valuedata;
          } else if (item.itemdata.colname == 'CP_C_REGION_CITY_ENAME' && item.itemdata.colname == e.colname) {
            // 收货人市
            this.replacement.formValue.CP_C_REGION_CITY_ID = item.itemdata.pid;
            this.replacement.formValue.CP_C_REGION_CITY_ENAME = item.itemdata.valuedata;
          } else if (item.itemdata.colname == 'CP_C_REGION_AREA_ENAME' && item.itemdata.colname == e.colname) {
            // 收货人区
            this.replacement.formValue.CP_C_REGION_AREA_ID = item.itemdata.pid;
            this.replacement.formValue.CP_C_REGION_AREA_ENAME = item.itemdata.valuedata;
          }
        }
      });
    },
    /* --------------- 表格事件 --------------- */
    onSelect(e) {
      // e为选中的数组对象RowArr
      this.hanldeSelect(e, true)
    },
    onSelectCancel(e) {
      this.hanldeSelect(e, false)
    },
    onSelectAll(e) {
      this.hanldeSelect(e, true)
    },
    onSelectAllCancel() {
      this.hanldeSelect([], false)
    },
    hanldeSelect(e, isAdd) {
      this.jordanTableConfig.selectionData = e;
      const arr = e.map(i => i._flagIndex)
      this.jordanTableConfig.data.forEach(i => {
        if (isAdd) {
          i._checked = arr.includes(i._flagIndex)
        } else {
          if (e.length) {
            arr.includes(i._flagIndex) && (i._checked = false)
          } else {
            i._checked = false
          }
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.cus-modal {
  height: 85vh;
  .subtablePart {
    height: 76vh;
    overflow: auto;
  }
}
</style>